export const PhoneNumber = (number: string | undefined) => {
    if(!number) return null
    const str = number;
    const modifiedNumber = str.replace(/[+\s]/g, "");
    
    return modifiedNumber

}